module.exports = __webpack_public_path__ + "img/67.c81326d2.png";